var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.247,
    height: 179.864,
    viewBox: "0 0 206.247 179.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M344.928,352.957a9.436,9.436,0,0,1-1.452.034.317.317,0,0,0-.349.275l-.926,6.949a2.821,2.821,0,0,1-.6,1.377,3,3,0,0,0-.675,2.293v11.8s-.06,1.574,1.15,1.574a17.478,17.478,0,0,0,4.359,0s.968-.183.968-1.636V364a2.843,2.843,0,0,0-.6-2.311,2.892,2.892,0,0,1-.58-1.369l-.962-7.095A.317.317,0,0,0,344.928,352.957Z",
    transform: "translate(-310.72 -290.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M343.745,377.091a17.655,17.655,0,0,1-2.189-.136,1.176,1.176,0,0,1-.871-.357,2.176,2.176,0,0,1-.463-1.424V363.389a3.21,3.21,0,0,1,.722-2.433,2.621,2.621,0,0,0,.553-1.277l.926-6.948a.519.519,0,0,1,.568-.447,9.194,9.194,0,0,0,1.411-.034h.005a.516.516,0,0,1,.548.445l.962,7.095a2.7,2.7,0,0,0,.54,1.273,3.035,3.035,0,0,1,.64,2.451v11.605c0,1.6-1.119,1.829-1.131,1.832A17.772,17.772,0,0,1,343.745,377.091Zm-.8-24.41a.119.119,0,0,0-.124.1l-.927,6.951a3.023,3.023,0,0,1-.64,1.475,2.812,2.812,0,0,0-.633,2.143v11.829a1.806,1.806,0,0,0,.353,1.141.785.785,0,0,0,.6.234l.025,0a17.308,17.308,0,0,0,4.309,0c.019,0,.794-.181.794-1.438l0-11.659a2.64,2.64,0,0,0-.556-2.149,3.1,3.1,0,0,1-.623-1.467l-.963-7.1a.118.118,0,0,0-.123-.1,9.7,9.7,0,0,1-1.48.034h-.016Z",
    transform: "translate(-310.212 -289.835)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M110.7,261.989h1.468a2.2,2.2,0,0,1,2.2,2.2v5.525a2.2,2.2,0,0,1-2.2,2.2H110.7a2.2,2.2,0,0,1-2.2-2.2V264.19A2.2,2.2,0,0,1,110.7,261.989Z",
    transform: "translate(-77.958 -188.236)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M20.43,575.311h4.787l2.277-18.465H20.429Z",
    transform: "translate(-14.678 -400.087)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M249.773,747.424H259.2a6.008,6.008,0,0,1,6.008,6.008v.2H249.773Z",
    transform: "translate(-245.242 -573.763)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M241.835,518.7s-2.075,2.345,1.361,11.487l-.605,50.127,11.133-.217,2.447-24.451,4.456-35.682Z",
    transform: "translate(-239.093 -409.43)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M259.031,390.014l-.122-.019c-14.242-2.172-24.99-4.254-25.1-4.275l-.134-.026,3.733-9.081c-.03-.949-.838-27.595.709-35.25,1.5-7.411,8.557-8.626,9.362-8.74l.808-2.676,10.205,5.31,1.78,6.126.362,16.789Z",
    transform: "translate(-233.679 -273.811)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M279.509,420.57a3.331,3.331,0,0,0-2.447,1.071H259.909l-6.283,1.337,1.032,7.957,22.351-4.807a3.342,3.342,0,1,0,2.5-5.557Z",
    transform: "translate(-248.01 -338.923)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 8.267,
    cy: 8.267,
    r: 8.267,
    transform: "translate(13.174 52.452) rotate(-61.337)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M287.455,269.982l-.4-.807,2.017-1s2.225-3.62,6.25-2.6,5.837,1.626,5.837,1.626l2.011,1.012-1.01,1,1.811.609-1.21.6,1.408.809-.758,4.148s-1.259-3.146-3.678-1.944-6.846-.621-6.846-.621l-3.846,7.442s-.793-2.609-2.208-1.913C286.833,278.344,283.219,272.589,287.455,269.982Z",
    transform: "translate(-270.837 -227.428)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M251.463,377.131,249.5,371.3l-.474-19.451.836-2.76a7.71,7.71,0,1,1,14.562,5.038l-4.48,11.48.228.442,9.706-.079,3.448,6.206Z",
    transform: "translate(-244.706 -283.628)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M590.638,418.355a2.988,2.988,0,0,0,.477-4.556l4.784-9.476-5.48.636-3.7,8.9a3,3,0,0,0,3.921,4.495Z",
    transform: "translate(-486.775 -327.249)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M489,519.63h-4.312L482.638,503H489Z",
    transform: "translate(-346.77 -361.399)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M707.342,693.2h-13.9v-.176a5.411,5.411,0,0,1,5.411-5.411h8.492Z",
    transform: "translate(-564.012 -530.79)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M405.3,519.63h-4.312L398.938,503H405.3Z",
    transform: "translate(-286.632 -361.399)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M619.895,693.2h-13.9v-.176a5.411,5.411,0,0,1,5.411-5.411H619.9Z",
    transform: "translate(-501.182 -530.79)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M400.629,312.572l-4.22,9.722-3.481,55.882,8.792-.352,2.4-26.639,7.407-23.726,4.258,26.451,1.759,23.211,7.275.315,2.9-64.864Z",
    transform: "translate(-282.314 -224.579)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M666.917,272.694,654.686,273l-7.181,3.686-.394,27.2-4.479,18.778s27.983,1.926,31.852-.888l-4.572-21.452,6.132-23.184Z",
    transform: "translate(-527.507 -232.676)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M612.6,286.515l-1.139-.769s-4.717,1.414-6.112,7.7c0,0-1.067,3.156-1.535,5.326-.537,2.488-12.394,25.348-12.394,25.348l7.1,2.036,13.015-21.047Z",
    transform: "translate(-490.709 -242.053)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M757.606,428.429a2.987,2.987,0,0,1,.8-4.511l-1.985-10.428,5.092,2.122,1.1,9.577a3,3,0,0,1-5.009,3.239Z",
    transform: "translate(-609.261 -333.836)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M746.164,288.55l1.306-.425s4.145,2.66,3.75,9.091c0,0,.155,3.328.007,5.542-.17,2.54,2.11,27.783,2.11,27.783h-7.385l-3.165-22.859Z",
    transform: "translate(-599.467 -243.763)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M696.284,210.52a8.479,8.479,0,1,1-8.479-8.479h0a8.458,8.458,0,0,1,8.479,8.437Z",
    transform: "translate(-553.871 -181.912)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M678.5,185.838c.993-2.136,2.915-1.714,4.6-.99,2.129-.472,4.154-1.886,6.447-1.05,2.26,3.286,9.845,2.319,8.232,7.669,0,1.282,2.412.536,1.991,2.635,1.279,4.04-4.616,11.693-8,10.081.837-1.534,2.749-5.018-.151-5.364-6.239,5.8-.644-11.053-8.482-6.151C680.533,195.045,676.98,188.214,678.5,185.838Z",
    transform: "translate(-553.014 -168.619)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M760.059,401.77a2.818,2.818,0,0,0,3.372-2.7l21.29-20.039-4.79-3.821-19.457,20.95a2.833,2.833,0,0,0-.415,5.611Z",
    transform: "translate(-610.23 -306.332)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M831.459,372.333l-4.142-4.854a1.263,1.263,0,0,1,.29-1.891L833,362.212a3.509,3.509,0,0,1,4.54,5.352l-4.167,4.779a1.263,1.263,0,0,1-1.913-.011Z",
    transform: "translate(-659.983 -296.395)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M549.952,569.753h-5.205l-2.477-20.078h7.683Z",
    transform: "translate(-389.615 -394.935)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M765.114,752.244H748.33v-.212a6.533,6.533,0,0,1,6.533-6.533h10.252Z",
    transform: "translate(-603.449 -572.38)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M697.76,569.753h-5.205l-2.476-20.078h7.683Z",
    transform: "translate(-495.813 -394.935)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M912.922,752.244H896.137v-.212a6.533,6.533,0,0,1,6.532-6.533h10.252Z",
    transform: "translate(-709.647 -572.38)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M789.805,378.854l5.247-19.386-6.807-3.826h-9.5l-3.7,3.954s-6.174,4.3-4.68,9.055l2.411,10.841-3.687,17.218-18.577,25.763-4.4,25.306,17.31,4.538,18.719-36.858,9.076,40.812,16.884-.849-5.818-49.485s-1.658-15.075-10.352-24.487Z",
    transform: "translate(-601.86 -292.273)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M913.573,417.938a2.818,2.818,0,0,0-.361-4.306l-4.071-27.465-5.843,1.845,5.849,26.452a2.833,2.833,0,0,0,4.426,3.474Z",
    transform: "translate(-714.792 -314.205)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M907.856,373.853l-6.339.731a1.263,1.263,0,0,1-1.407-1.3l.205-6.358a3.509,3.509,0,0,1,6.974-.783l1.643,6.125a1.263,1.263,0,0,1-1.076,1.582Z",
    transform: "translate(-712.501 -297.58)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M841.146,287.277v-8.168a10.945,10.945,0,0,1,21.89,0v8.168a1.472,1.472,0,0,1-1.47,1.47h-18.95A1.472,1.472,0,0,1,841.146,287.277Z",
    transform: "translate(-670.137 -229.421)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 8.025,
    cy: 8.025,
    r: 8.025,
    transform: "translate(168.814 47.919) rotate(-28.663)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M831.948,287.267a8.668,8.668,0,0,1,8.658-8.658h1.634a8.668,8.668,0,0,1,8.658,8.658v.163h-3.453l-1.178-3.3-.235,3.3h-1.784l-.594-1.664-.119,1.664H831.948Z",
    transform: "translate(-663.528 -236.926)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M868.508,306.422a1.449,1.449,0,0,1-.115-1.538c1.731-3.293,4.155-9.377.938-13.129l-.231-.27h9.34v14.023l-8.485,1.5a1.5,1.5,0,0,1-.26.023,1.465,1.465,0,0,1-1.187-.606Z",
    transform: "translate(-689.592 -246.177)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M506.687,362.838a3.227,3.227,0,0,0-.325.391l-15.218-.372-1.775-3.244-5.246,2.039,2.585,6.049a2.455,2.455,0,0,0,2.553,1.473l17.194-2.077a3.222,3.222,0,1,0,.233-4.259Z",
    transform: "translate(-413.619 -295.126)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M154.372,519.576h5l2.38-19.3h-7.385Z",
    transform: "translate(-110.914 -359.442)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M383.519,693.571h9.855a6.28,6.28,0,0,1,6.28,6.279v.2H383.519Z",
    transform: "translate(-341.337 -535.071)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M296.426,515.736l4.6-1.966-5.393-18.684-6.791,2.9Z",
    transform: "translate(-207.53 -355.713)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M543.007,684.251l9.062-3.871h0a6.281,6.281,0,0,1,8.242,3.308l.08.187-14.837,6.339Z",
    transform: "translate(-455.927 -525.229)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M186.455,253.534l.362,5.864-10.577,1.132-11.067,1.184,3.257-8.9Z",
    transform: "translate(-118.675 -181.641)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M419.921,316.795c-.12-.047-12.066-4.694-19.4-.894l-.18.094-1.464-7.206-.834-15.491,5.428-2.565,1.494-3.348,10.179-.6,2.092,2.869,7.122,2.334L420.1,316.864Z",
    transform: "translate(-351.769 -242.798)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M477.1,316.246l1.259-9.893,2.867-.873.048.018a3.609,3.609,0,0,1,2.051,2.778c.409,2.071,3.493,14.955,3.524,15.085l.031.129-7.244,2.9Z",
    transform: "translate(-408.574 -256.233)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M425.36,479.731,435,477.753l-15.413-42.529-5.275-14.506s-3.346-11.631-4.857-16.132l-.912-6.039-21.594,2.39s-6.031,8.857-4.2,23.294l-.829,54.263,9.643.494,8.077-54.727,14.176,30s4.468,12.8,7.665,15.577Z",
    transform: "translate(-340.192 -323.1)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M386.23,369.9a3.213,3.213,0,0,0-.508.028l-10.074-11.413,1.172-3.508-5.063-2.461-2.678,6.008a2.456,2.456,0,0,0,.655,2.873l13.213,11.2a3.222,3.222,0,1,0,3.282-2.724Z",
    transform: "translate(-330.809 -290.052)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M375.9,323.6l3.938-11.218c.443-1.322,1-2.126,1.648-2.388a1.017,1.017,0,0,1,.817-.008l1.766,2.231,1.639,6.885-4.2,9.885Z",
    transform: "translate(-335.86 -259.413)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M420.946,230.606H403.656a1.343,1.343,0,0,1-1.341-1.341v-7.452a9.986,9.986,0,1,1,19.972,0v7.452A1.343,1.343,0,0,1,420.946,230.606Z",
    transform: "translate(-354.842 -188.943)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 7.321,
    cy: 7.321,
    r: 7.321,
    transform: "translate(52.19 26.846)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M437.526,229.4H426.954l-.108-1.518L426.3,229.4h-1.628l-.215-3.008-1.074,3.008h-3.15v-.149a7.908,7.908,0,0,1,7.9-7.9h1.491a7.908,7.908,0,0,1,7.9,7.9Z",
    transform: "translate(-367.718 -195.79)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M423.427,247.285a1.364,1.364,0,0,1-.237-.021l-7.741-1.366V233.1h8.522l-.211.246c-2.935,3.423-.724,8.974.856,11.979a1.322,1.322,0,0,1-.105,1.4A1.336,1.336,0,0,1,423.427,247.285Z",
    transform: "translate(-364.278 -204.231)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M762.928,392.718a9.434,9.434,0,0,1-1.453.034.317.317,0,0,0-.349.275l-.927,6.949a2.82,2.82,0,0,1-.6,1.377,3,3,0,0,0-.675,2.293v11.8s-.06,1.574,1.15,1.574a17.484,17.484,0,0,0,4.359,0s.968-.183.968-1.636V403.765a2.843,2.843,0,0,0-.6-2.311,2.9,2.9,0,0,1-.58-1.369l-.962-7.095A.317.317,0,0,0,762.928,392.718Z",
    transform: "translate(-611.047 -318.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M761.745,416.851a17.63,17.63,0,0,1-2.189-.136,1.178,1.178,0,0,1-.872-.357,2.175,2.175,0,0,1-.463-1.424V403.149a3.211,3.211,0,0,1,.722-2.433,2.618,2.618,0,0,0,.553-1.277l.926-6.948a.519.519,0,0,1,.568-.447,9.188,9.188,0,0,0,1.411-.034h.005a.516.516,0,0,1,.549.445l.962,7.095a2.7,2.7,0,0,0,.54,1.273,3.035,3.035,0,0,1,.64,2.451V414.88c0,1.6-1.119,1.829-1.13,1.831A17.749,17.749,0,0,1,761.745,416.851Zm-.8-24.41a.119.119,0,0,0-.124.1l-.927,6.95a3.023,3.023,0,0,1-.64,1.475,2.812,2.812,0,0,0-.633,2.143v11.829a1.808,1.808,0,0,0,.353,1.141.786.786,0,0,0,.6.234l.025,0a17.313,17.313,0,0,0,4.309,0c.019,0,.794-.181.794-1.438l0-11.659a2.64,2.64,0,0,0-.556-2.149,3.1,3.1,0,0,1-.623-1.467l-.962-7.1a.118.118,0,0,0-.123-.1,9.681,9.681,0,0,1-1.479.034Z",
    transform: "translate(-610.54 -318.402)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M528.7,301.749h1.468a2.2,2.2,0,0,1,2.2,2.2v5.525a2.2,2.2,0,0,1-2.2,2.2H528.7a2.2,2.2,0,0,1-2.2-2.2v-5.525A2.2,2.2,0,0,1,528.7,301.749Z",
    transform: "translate(-378.286 -216.803)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M585.928,358.718a9.431,9.431,0,0,1-1.452.034.317.317,0,0,0-.349.275l-.927,6.949a2.817,2.817,0,0,1-.6,1.377,3,3,0,0,0-.675,2.293v11.8s-.06,1.574,1.149,1.574a17.485,17.485,0,0,0,4.359,0s.968-.183.968-1.636V369.765a2.843,2.843,0,0,0-.6-2.311,2.894,2.894,0,0,1-.58-1.369l-.962-7.095A.317.317,0,0,0,585.928,358.718Z",
    transform: "translate(-483.875 -294.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M584.746,382.851a17.648,17.648,0,0,1-2.189-.136,1.177,1.177,0,0,1-.872-.357,2.176,2.176,0,0,1-.463-1.423V369.149a3.209,3.209,0,0,1,.722-2.433,2.625,2.625,0,0,0,.553-1.277l.926-6.948a.519.519,0,0,1,.568-.447,9.193,9.193,0,0,0,1.411-.034h.005a.516.516,0,0,1,.549.445l.962,7.1a2.7,2.7,0,0,0,.539,1.273,3.035,3.035,0,0,1,.64,2.451V380.88c0,1.6-1.119,1.829-1.13,1.832A17.771,17.771,0,0,1,584.746,382.851Zm-.8-24.41a.119.119,0,0,0-.124.1l-.927,6.95a3.022,3.022,0,0,1-.64,1.475,2.813,2.813,0,0,0-.632,2.143v11.829a1.809,1.809,0,0,0,.353,1.141.786.786,0,0,0,.6.234h.025a17.3,17.3,0,0,0,4.309,0c.019,0,.794-.181.794-1.438l0-11.659a2.638,2.638,0,0,0-.556-2.149,3.1,3.1,0,0,1-.623-1.467l-.962-7.1a.118.118,0,0,0-.123-.1,9.664,9.664,0,0,1-1.48.034Z",
    transform: "translate(-483.368 -293.974)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M351.7,267.749h1.468a2.2,2.2,0,0,1,2.2,2.2v5.525a2.2,2.2,0,0,1-2.2,2.2H351.7a2.2,2.2,0,0,1-2.2-2.2v-5.525A2.2,2.2,0,0,1,351.7,267.749Z",
    transform: "translate(-251.114 -192.375)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M555.928,322.718a9.417,9.417,0,0,1-1.452.034.317.317,0,0,0-.349.275l-.926,6.949a2.82,2.82,0,0,1-.6,1.377,3,3,0,0,0-.675,2.293v11.8s-.06,1.574,1.15,1.574a17.486,17.486,0,0,0,4.359,0s.968-.183.968-1.636V333.765a2.843,2.843,0,0,0-.6-2.311,2.9,2.9,0,0,1-.58-1.369l-.962-7.095A.317.317,0,0,0,555.928,322.718Z",
    transform: "translate(-462.32 -268.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M554.746,346.851a17.626,17.626,0,0,1-2.189-.136,1.177,1.177,0,0,1-.872-.357,2.176,2.176,0,0,1-.464-1.424V333.149a3.211,3.211,0,0,1,.722-2.433,2.622,2.622,0,0,0,.553-1.277l.926-6.948a.519.519,0,0,1,.568-.447,9.181,9.181,0,0,0,1.411-.034h.006a.516.516,0,0,1,.549.445l.962,7.095a2.7,2.7,0,0,0,.54,1.273,3.034,3.034,0,0,1,.639,2.451V344.88c0,1.6-1.119,1.829-1.13,1.832A17.768,17.768,0,0,1,554.746,346.851Zm-.8-24.41a.119.119,0,0,0-.124.1l-.927,6.95a3.02,3.02,0,0,1-.64,1.475,2.813,2.813,0,0,0-.633,2.143v11.829a1.809,1.809,0,0,0,.353,1.141.786.786,0,0,0,.6.234l.025,0a17.3,17.3,0,0,0,4.309,0c.019,0,.794-.181.794-1.438l0-11.659a2.639,2.639,0,0,0-.556-2.149,3.1,3.1,0,0,1-.623-1.467l-.963-7.1a.118.118,0,0,0-.123-.1,9.665,9.665,0,0,1-1.479.034Z",
    transform: "translate(-461.813 -268.108)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M321.7,231.749h1.468a2.2,2.2,0,0,1,2.2,2.2v5.525a2.2,2.2,0,0,1-2.2,2.2H321.7a2.2,2.2,0,0,1-2.2-2.2v-5.525A2.2,2.2,0,0,1,321.7,231.749Z",
    transform: "translate(-229.559 -166.509)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.038,
    cy: 7.038,
    r: 7.038,
    transform: "translate(8.78 5.912)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 7.038,
    cy: 7.038,
    r: 7.038,
    transform: "translate(170.93)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 5.067,
    cy: 5.067,
    r: 5.067,
    transform: "translate(92.389 21.676)",
    fill: "#f0f0f0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitePlaceholder);
export default __webpack_public_path__ + "static/media/invitePlaceholder.3455b1c6.svg";
export { ForwardRef as ReactComponent };